import React, { useContext } from 'react';
import SubmissionTabInfosUpdate from './SubmissionTabInfosUpdate';
import { SubmissionContext } from '../../../Context/SubmissionProvider';
import SubmissionTabInfosCommercial from './SubmissionTabInfosCommercial';

type SubmissionTabInfosProps = {
  goToOverview(): void;
};

const SubmissionTabInfos: React.FC<SubmissionTabInfosProps> = ({ goToOverview }) => {
  const { submission } = useContext(SubmissionContext);

  if (!submission) {
    return null;
  }

  // UPDATE GAME
  const renderUpdateGame = () => {
    return <SubmissionTabInfosUpdate goToOverview={goToOverview} />;
  };

  // COMMERCIAL
  const renderCommercial = () => {
    return <SubmissionTabInfosCommercial />;
  };

  return (
    <>
      {renderUpdateGame()}
      {renderCommercial()}
    </>
  );
};

export default SubmissionTabInfos;
